import { CollideEvent, CollideId, isPowerCollider } from '../../defs/collide';
import type { TunaCanBlockEntity } from '../../entities/BlockEntity';
import { despawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { TunaCanEffect } from '../effects/TunaCanEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

export class TunaCanCollision implements ICollision {
  private readonly scene: GameScene;
  private readonly entity: TunaCanBlockEntity;
  private readonly resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this.resolveTap,
    attack: this.resolveAttack,
  };

  constructor(scene: GameScene, entity: TunaCanBlockEntity) {
    this.scene = scene;
    this.entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this.resolvers[event.id]?.call(this, event) ?? false;
  }

  private async resolveTap(event: CollideEvent) {
    await new InvalidEffect(this.entity).execute();
    return false;
  }

  private async resolveAttack(event: CollideEvent) {
    const collider = event.collider;

    // Only attack if is a power collision (from power blocks or boosters)
    if (isPowerCollider(collider?.type)) {
      await this.attack();
      return true;
    }

    return false;
  }

  private async attack() {
    const entity = this.entity;
    const position = entity.c.position.mapPosition;

    // Despawn the block - will be replaced by tuna fish block on TunaCanEffect
    despawnBlockEntity(this.scene, this.entity);

    // Play break animation
    new BreakEffect(this.scene, {
      position,
      size: entity.c.block.props,
      color: 0xf6ed4d,
    }).execute();

    // Play tuna can effect, that will spawn tuna fish block
    await new TunaCanEffect(this.scene, {
      subject: this.entity,
    }).execute();
  }
}
